import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import AssetServices from "../../../services/AssetServices";
import TransferForm from "../Transfer/TransferForm";
import Swal from "sweetalert2";

const AddTransferItem = () => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [stores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);
  const [requisition, setRequisiton] = useState([]);
  const [selectedRequisition, setSelectedRequisition] = useState("");
  const [run, setRun] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [items, setItems] = useState([
    {
      name: "",
      inventory: "",
      description: "",
      currentQty: "",
      transferQty: 0,
      error: "",
      unit: "",
      assetOptions: [],
      selectedAssets: [],
      hasAssets: false, // ✅ NEW FIELD
    },
  ]);

  const [partOptions, setPartOptions] = useState([]);

  // 🔄 Handle input updates
  const handleItemChange = (index, field, value) => {
    setItems((prev) => {
      const updated = [...prev];
      updated[index][field] = value;

      if (field === "transferQty") {
        if (value > updated[index].currentQty) {
          updated[index].error = `Transfer Qty cannot exceed Current Qty`;
        } else if (value <= 0) {
          updated[index].error = `Transfer Qty must be greater than 0`;
        } else {
          updated[index].error = "";
        }
      }
      return updated;
    });
  };

  // 🧠 Fetch assets for selected inventory
  const handlePartSelect = async (index, selectedOption) => {
    if (!selectedOption) return;

    // Prevent duplicate inventory
    setItems((prev) => {
      if (prev.some((item) => item.inventory === selectedOption.value)) {
        Swal.fire({
          icon: "error",
          title: "Duplicate Item",
          text: "This inventory is already added.",
        });
        return prev;
      }

      const newItems = [...prev];
      newItems[index] = {
        ...newItems[index],
        inventory: selectedOption.value,
        name: selectedOption.label,
        currentQty: selectedOption.currentStock,
        description: selectedOption.description,
        unit: selectedOption.unit,
        selectedAssets: [],
        assetOptions: [],
        transferQty: 0,
        hasAssets: false, // ✅ reset
      };
      return newItems;
    });

    try {
      const res = await AssetServices.getAssestbyInventoryId(selectedOption.value);
      const assets = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res)
        ? res
        : [];

      let assetOptions = [];

      if (assets.length > 0) {
        assetOptions = assets.map((a) => ({
          value: a._id,
          serialNumber: a.serialNumber || "N/A",
          model: a.model || "N/A",
          label: `${a.serialNumber || "N/A"} | ${a.model || "N/A"}`,
        }));
      }

      // ✅ Ensure manual entry allowed if no assets
      setItems((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          assetOptions,
          selectedAssets: [],
          hasAssets: assets.length > 0, // ✅ TRUE if assets exist
          transferQty: assets.length > 0 ? 0 : updated[index].transferQty,
        };
        return updated;
      });
    } catch (error) {
      console.error("❌ Error fetching assets:", error);
      Swal.fire({
        icon: "error",
        title: "Asset Fetch Failed",
        text: "Could not fetch assets for this inventory.",
      });
    }
  };

  // 🎯 Handle multiple asset selection (auto-calculates transferQty)
  const handleAssetSelect = useCallback((index, selectedAssets) => {
    setItems((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index].selectedAssets = selectedAssets || [];

      if (updatedItems[index].hasAssets) {
        updatedItems[index].transferQty = selectedAssets.length; // ✅ auto update only if assets exist
      }

      updatedItems[index].error = "";
      return updatedItems;
    });
  }, []);

  // ➕ Add item
  const handleAddItem = (e) => {
    e.preventDefault();
    const lastItem = items[items.length - 1];
    if (!lastItem || !lastItem.inventory || !lastItem.name) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text: "Please fill all fields before adding another item.",
      });
      return;
    }

    setItems((prev) => [
      ...prev,
      {
        name: "",
        inventory: "",
        description: "",
        currentQty: "",
        transferQty: 0,
        error: "",
        unit: "",
        assetOptions: [],
        selectedAssets: [],
        hasAssets: false, // ✅ added
      },
    ]);
  };

  // 🗑 Remove item
  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  // 🚀 Submit transfer
  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorMessage = "";

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.transferQty <= 0) {
        errorMessage = `Item ${i + 1}: Transfer Qty must be greater than 0.`;
      } else if (item.transferQty > item.currentQty) {
        errorMessage = `Item ${i + 1}: Transfer Qty cannot exceed Current Qty.`;
      }

      if (errorMessage) break;
    }

    if (!selectedRequisition) {
      errorMessage = "Please select a Transfer No!";
    }

    if (errorMessage) {
      Swal.fire({ icon: "warning", title: "Validation Error", text: errorMessage });
      return;
    }

    try {
      setIsSubmitting(true);

      const requestData = {
        transferId: selectedRequisition,
        items: items.map((item) => ({
          inventory: item.inventory,
          transferQty: item.transferQty,
          assets: item.selectedAssets.map((a) => a.value),
        })),
      };

      await RequestServies.submitTransfer(requestData);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Transfer submitted successfully.",
      });

      setItems([
        {
          name: "",
          inventory: "",
          description: "",
          currentQty: "",
          transferQty: 0,
          error: "",
          unit: "",
          assetOptions: [],
          selectedAssets: [],
          hasAssets: false,
        },
      ]);
      setRun((r) => r + 1);
    } catch (error) {
      console.error("Error during submission:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Error during submission.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // 🏪 Fetch transfer requisitions
  useEffect(() => {
    if (!selectedStore) return;
    const status = "open";
    RequestServies.getTrasfer(selectedStore, status)
      .then((res) => {
        setRequisiton(res?.data?.data || []);
        setSelectedRequisition(res?.data?.data?.[0]?._id || "");
      })
      .catch((error) => console.error(error));
  }, [selectedStore, run]);

  // 📦 Fetch inventory list
  useEffect(() => {
    setLoading(true);
    ProductServices.getInventory(selectedStore)
      .then((res) => {
        const options = res.data.data.map((part) => ({
          value: part._id,
          description: part.masterItem?.description,
          unit: part.masterItem?.unit?.name,
          label: `${part.masterItem?.partNo} | ${part.masterItem?.description}`,
          currentStock: part.currentStock,
        }));
        setPartOptions(options);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  }, [selectedStore]);

  return (
    <>
      <TransferForm
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun((prev) => prev + 1)}
      />

      <div className="row">
        <div className="col-xl-12">
          {/* Filter Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>

            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4">
                      <label>Select Store</label>
                      <select
                        className="form-select mb-3"
                        value={selectedStore}
                        onChange={(e) => setSelectedStore(e.target.value)}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-xl-4">
                      <label>Select Transfer No</label>
                      <select
                        className="form-select mb-3"
                        value={selectedRequisition}
                        onChange={(e) => setSelectedRequisition(e.target.value)}
                      >
                        {requisition.length > 0 ? (
                          requisition.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.transferNo}
                            </option>
                          ))
                        ) : (
                          <option disabled>No records found</option>
                        )}
                      </select>
                    </div>

                    <div className="col-xl-4">
                      <button
                        className="btn btn-sm btn-primary mt-4"
                        onClick={() => setIsModelOpen(true)}
                      >
                        Generate New Transfer No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          {/* Add Transfer Item Section */}
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa"><i className="fa fa-plus me-2"></i>Add Transfer Item</div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>

            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <form>
                      {items.map((item, index) => (
                        <div key={index} className="row align-items-center">
                          {/* Inventory */}
                          <div className="form-group mb-2 col-md-2">
                            <label>Select Inventory</label>
                            <Select
                              options={loading ? [] : partOptions}
                              onChange={(opt) => handlePartSelect(index, opt)}
                              placeholder={loading ? "Loading..." : "Search by Part No / Desc"}
                            />
                          </div>

                          {/* Description */}
                          <div className="form-group mb-2 col-md-2">
                            <label>Description</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={item.description}
                              placeholder="Description"
                              readOnly
                            />
                          </div>

                          {/* Asset Selection */}
                          <div className="form-group mb-2 col-md-2">
                            <label>Select Asset(s)</label>
                            <Select
                              key={index + (item.assetOptions?.length || 0)}
                              options={item.assetOptions || []}
                              value={item.selectedAssets}
                              onChange={(opts) => handleAssetSelect(index, opts || [])}
                              placeholder="Select Asset(s)"
                              isMulti
                              isOptionDisabled={(option) => option.isDisabled}
                              formatOptionLabel={(option) =>
                                option.value === "no-assets" ? (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontStyle: "italic",
                                      fontWeight: 500,
                                    }}
                                  >
                                    No Assets Available
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong style={{ color: "#666" }}>
                                      S.No. {option.serialNumber} | M.No. {option.model}
                                    </strong>
                                  </div>
                                )
                              }
                            />
                          </div>

                          {/* Current Qty */}
                          <div className="form-group mb-2 col-md-2">
                            <label>
                              {item.unit ? `Current Qty (${item.unit})` : "Current Qty"}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={item.currentQty}
                              readOnly
                            />
                          </div>

                          {/* Transfer Qty */}
                          <div className="form-group mb-2 col-md-2">
                            <label>
                              {item.unit ? `Transfer Qty (${item.unit})` : "Transfer Qty"}
                            </label>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              value={item.transferQty || ""}
                              onChange={(e) =>
                                !item.hasAssets &&
                                handleItemChange(
                                  index,
                                  "transferQty",
                                  e.target.value === "" ? 0 : Number(e.target.value)
                                )
                              }
                              placeholder="0"
                              min="0"
                              readOnly={item.hasAssets}
                            />
                            <p className="text-danger">{item.error}</p>
                          </div>

                          {/* Delete Button */}
                          <div className="form-group mb-2 col-md-1">
                            <button
                              className="btn btn-danger btn-xs sharp mt-1"
                              onClick={(e) => handleRemoveItem(e, index)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      ))}

                      <div className="row mt-3">
                        <div className="form-group mb-2 col-md-2">
                          <button className="btn btn-sm btn-primary" onClick={handleAddItem}>
                            Add Item
                          </button>
                        </div>
                        <div className="form-group mb-2 col-md-2">
                          <button
                            type="submit"
                            className="btn btn-sm btn-primary"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTransferItem;
